import { Radio, Stack, Text } from '@lightspeed/design-system-react'
import { T, useT } from '@transifex/react'
import React from 'react'
import {
  DefinedFulfilmentType,
  FulfilmentType,
} from '../../../../../models/fulfilment'
import { LineItemFulfilmentNote } from '../LineItemFulfilmentNote'

export const TContext = 'Line item fulfilment popover'
export const TestId = 'lif-details-view'

type Props = {
  productName: string
  fulfilmentType?: DefinedFulfilmentType
  fulfilmentNote?: string
  onSelect: (opt: DefinedFulfilmentType) => void
  onNoteChange: (note: string) => void
}

export const LineItemFulfilmentDetailsView: React.FC<Props> = ({
  productName,
  fulfilmentType = FulfilmentType.DELIVERY,
  fulfilmentNote = '',
  onSelect,
  onNoteChange,
}: Props) => {
  const t = useT()
  return (
    <Stack space={6} data-testid={TestId}>
      <Text type="label">
        <h3>
          {t('Choose how “{productName}” will be fulfilled', {
            _context: TContext,
            productName,
          })}
        </h3>
      </Text>

      <Text>
        <T
          _str="Only one fulfillment method can be selected for the items that require fulfillment. To record another method, create another sale."
          _context={TContext}
        />
      </Text>

      <Text>
        {t(
          'Record the fulfillment details for “{productName}” in the fulfillment note.',
          {
            _context: TContext,
            productName,
          }
        )}
      </Text>

      <Stack space={2}>
        <Text type="label">
          <T _str="Fulfillment method" _context={TContext} />
        </Text>
        <Stack space={2}>
          <Radio
            className="vd-pl0"
            name="fulfilment_method"
            label={t('Delivery', { _context: TContext })}
            checked={fulfilmentType === FulfilmentType.DELIVERY}
            value={FulfilmentType.DELIVERY}
            onChange={() => onSelect(FulfilmentType.DELIVERY)}
          />
          <Radio
            className="vd-pl0"
            name="fulfilment_method"
            label={t('Pickup', { _context: TContext })}
            checked={fulfilmentType === FulfilmentType.PICKUP}
            value={FulfilmentType.PICKUP}
            onChange={() => onSelect(FulfilmentType.PICKUP)}
          />
        </Stack>
      </Stack>

      <LineItemFulfilmentNote note={fulfilmentNote} onChange={onNoteChange} />
    </Stack>
  )
}
